module.exports = __webpack_public_path__ + "img/058.7b513b86.png";